function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
    >
      <g clipPath="url(#clip0_4701_192188)">
        <path
          stroke="#EC6726"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.704"
          d="M5.11 10.222l3.596 3.407 6.626-6.815"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4701_192188">
          <path fill="#fff" d="M0 0H20.444V20.444H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default CheckIcon;
